// Figures supplied by Ebrahim in the website review on 2026-09-14.
// These describe one networking redesign, not typical or promised results.
export const customerConnectivity = {
  setupTime: {
    before: "~2\u00a0weeks",
    after: "~1\u00a0hour",
    label: "Average customer-site access setup",
  },
  monthlyCost: {
    before: "$2,000",
    after: "<$100",
    label: "Networking & connectivity / month",
  },
  change: "I redesigned customer connectivity around outbound connections and resolved IP conflicts.",
} as const;
